import { ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { filter, Observable, OperatorFunction } from 'rxjs';
import { internalStripePaymentActions } from './stripe-payment.state';

export function getPaymentClientSecretPublicPart(clientSecret: string): string {
  const secretIndex = clientSecret?.indexOf('_secret');
  return secretIndex >= 0 ? clientSecret.substring(0, secretIndex) : clientSecret;
}

export const ofPaymentSuccess: (key: string) => OperatorFunction<Action, ReturnType<typeof internalStripePaymentActions.paymentSuccess>> =
  (key: string) => ((action: Observable<Action>) =>
    action.pipe(
      ofType(internalStripePaymentActions.paymentSuccess),
      filter((action) => action.data.paymentKey === key)
    )
  )
  
export const ofPaymentTimeout: (key: string) => OperatorFunction<Action, ReturnType<typeof internalStripePaymentActions.paymentTimeout>> =
  (key: string) => ((action: Observable<Action>) =>
    action.pipe(
      ofType(internalStripePaymentActions.paymentTimeout),
      filter((action) => action.data.paymentKey === key)
    )
  )
  
export const ofPaymentFailed: (key: string) => OperatorFunction<Action, ReturnType<typeof internalStripePaymentActions.paymentFail>> =
  (key: string) => ((action: Observable<Action>) =>
    action.pipe(
      ofType(internalStripePaymentActions.paymentFail),
      filter((action) => action.data.paymentKey === key)
    )
  )
  
export const ofPaymentNotSuccess: (key: string) => OperatorFunction<Action,
  ReturnType<typeof internalStripePaymentActions.paymentTimeout>
  | ReturnType<typeof internalStripePaymentActions.paymentFail>
  > =
  (key: string) => ((action: Observable<Action>) =>
    action.pipe(
      ofType(
        internalStripePaymentActions.paymentTimeout,
        internalStripePaymentActions.paymentFail
      ),
      filter((action) => action.data.paymentKey === key)
    )
  )

export const ofPaymentNotFail: (key: string) => OperatorFunction<Action,
  ReturnType<typeof internalStripePaymentActions.paymentSuccess>
  | ReturnType<typeof internalStripePaymentActions.paymentTimeout>
  > =
  (key: string) => ((action: Observable<Action>) =>
    action.pipe(
      ofType(
        internalStripePaymentActions.paymentSuccess,
        internalStripePaymentActions.paymentTimeout
      ),
      filter((action) => action.data.paymentKey === key)
    )
  )

export const ofPaymentResult: (key: string) => OperatorFunction<Action,
  ReturnType<typeof internalStripePaymentActions.paymentSuccess>
  | ReturnType<typeof internalStripePaymentActions.paymentTimeout>
  | ReturnType<typeof internalStripePaymentActions.paymentFail>
  > =
  (key: string) => ((action: Observable<Action>) =>
    action.pipe(
      ofType(
        internalStripePaymentActions.paymentSuccess,
        internalStripePaymentActions.paymentTimeout,
        internalStripePaymentActions.paymentFail
      ),
      filter((action) => action.data.paymentKey === key)
    )
  )
